<div class="upload-wrapper">
    <mat-card appearance="outlined" style="width: 100%; position: relative">
        <mat-card-header>
            <mat-label style="margin-bottom: 10px">{{ "general.supportedFile" | transloco }}: {{ supportedFiles }}</mat-label>
            @if (showHelpButton) {
                <app-video-link videoLink="uploadResource" style="position: absolute; right: 15px; top: 0px"></app-video-link>
            }
        </mat-card-header>
        <mat-card-content>
            <div id="drop_zone" appDnd (fileDropped)="onFileDropped($event)">
                <input
                    type="file"
                    accept="{{ fileExtension }}"
                    #fileDropRef
                    id="fileDropRef"
                    multiple
                    (change)="fileBrowseHandler($event.target['files'])"
                    [disabled]="selectedFiles.length >= limitUploadsCount"
                />
                <h3>{{ "general.dragAndDropFileHere" | transloco }}</h3>
                <h3>{{ "general.or" | transloco }}</h3>
                <label for="fileDropRef" [ngClass]="{ disabled: selectedFiles.length >= limitUploadsCount }">{{ "general.browseForFile" | transloco }}</label>
            </div>
            <button color="warn" mat-raised-button [disabled]="selectedFiles.length == 0 || uploading" (click)="uploadFiles()">{{ "general.uploadFiles" | transloco }}</button>
            <button color="accent" mat-raised-button [disabled]="selectedFiles.length == 0 || uploading" (click)="clearList()" style="margin-left: 10px">{{ "general.clear" | transloco }}</button>

            <div class="files-list">
                @for (file of selectedFiles; track file; let i = $index) {
                    <div class="single-file">
                        <div class="file-icon" style="width: 50px; opacity: 0.6">
                            <fa-icon [icon]="faFileUpload"></fa-icon>
                        </div>
                        <div style="width: 100%">
                            <span class="name">
                                {{ file.fileName + "." + file.fileType }}
                            </span>
                            <br />
                            <span class="size">
                                {{ file.formattedSize }}
                            </span>
                            <div class="progress-wrapper">
                                <mat-progress-bar mode="determinate" [color]="file.uploadStatus == 3 ? 'accent' : 'warn'" [value]="file.progress"></mat-progress-bar>
                                <div class="delete">
                                    <mat-icon (click)="deleteFile(file.fileId)">delete_forever</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </mat-card-content>
    </mat-card>
</div>

<ng-template let-modal #uploadModal class="transparentDialog">
    <div mat-dialog-content>
        <br />
        <br />
        <br />
        <div fxLayout="column" fxLayoutAlign="center center">
            <div>
                <app-loading [type]="9" [size]="'40px'"></app-loading>
            </div>
            <div style="margin: 5px">{{ formattedUploadingSize }} / {{ formattedTotalSize }}</div>
            <div>
                <circle-progress
                    [percent]="uploadPercentage"
                    [maxPercent]="100"
                    [radius]="50"
                    [outerStrokeColor]="'#78C000'"
                    [innerStrokeColor]="'#C7E596'"
                    [animationDuration]="300"
                    [showSubtitle]="false"
                    [showUnits]="true"
                    [showTitle]="true"
                    [unitsColor]="'#FFFFFF'"
                    [titleColor]="'#FFFFFF'"
                    [titleFontWeight]="'400'"
                    [startFromZero]="false"
                ></circle-progress>
            </div>
        </div>
        <br />
        <br />
    </div>
</ng-template>
